import { render, staticRenderFns } from "./PlotEdit.vue?vue&type=template&id=5903a122"
import script from "./PlotEdit.vue?vue&type=script&lang=js"
export * from "./PlotEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports